import reduce from 'lodash/reduce';
import isPlainObject from 'lodash/isPlainObject';
import { Constants } from '../helpers/Constants';
import axios from 'axios';
import dayjs from 'dayjs';
import BetterTag from '../components/mellro-primitives/BetterTag';

export function setupAxios(axios, store) {
	axios.interceptors.request.use(config => {
		let authToken = localStorage.getItem("authToken");

		if (authToken) {
			config.headers.Authorization = `Bearer ${authToken}`;
		}

		return config;
	},
		err => Promise.reject(err)
	);

	axios.interceptors.response.use(function (response) {
		return response;
	}, function (error) {
		if (process.env.NODE_ENV !== 'development') {
			if (error.response?.status == 401) {
				localStorage.removeItem('authToken');
				localStorage.removeItem('authUser');
			}

			if (error.response?.status == 403) {
				// window.location.href = '/error/error-v1';
			}

			if (error.response?.status == 500) {
				// window.location.href = '/error/error-v2';
			}

			if (error.response?.status == 404) {
				// window.location.href = '/error/error-v3';
			}
		}
		return Promise.reject(error);
	});
}

export const allowOnlyNumbersInput = (input) => {
	let value = input.target.value;

	value = value.replace(/[^\d.]+/g, '');

	input.target.value = value;

	return input.target.value;
};

export const allowOnlyPercentageInput = (input) => {
	// Padroniza a string para remover espaços em branco
	input.target.value = input.target.value.replace(/\s/g, "");

	// // Define a regex para permitir apenas números, vírgulas e pontos
	input.target.value = input.target.value.replace(/^(\d*[.]?\d{0,2}).*/, '$1');

	//permite valores de 0 a 100 apenas
	if (Number(input.target.value) > 100) {
		input.target.value = '100'
	}

	// Retorna o número convertido
	return input.target.value;
};

export function parseQuery(query, _prefix = '') {
	return reduce(query, (acc, val, key) => {
		const prefix = _prefix ? `${_prefix}[${key}]` : key;
		if (isPlainObject(val)) {
			return { ...acc, ...parseQuery(val, prefix) };
		}

		return { ...acc, [prefix]: val };
	}, {});
};

export const adicionarCasasDecimais = (numero) => {
	// Verifica se o número possui casas decimais
	if (Number.isInteger(numero)) {
		// Adiciona duas casas decimais zeradas
		numero = numero.toFixed(2);
	}

	return numero;
}

export const buscaCep = (input, setFieldValue, nomeEndereco, nomeBairro, nomeCidade, nomeUf) => {
	if (input.target.value.length > 8) {
		var cep = input.target.value.replace(/[^0-9]/, "");

		const instance = axios.create();

		instance
			.get(`https://viacep.com.br/ws/${cep}/json/`, {
				transformRequest: (data, headers) => {
					delete headers.common["Authorization"];
				},
			})
			.then((res) => {
				setFieldValue(nomeEndereco, res.data.logradouro);
				setFieldValue(nomeBairro, res.data.bairro);
				setFieldValue(nomeCidade, res.data.localidade);
				setFieldValue(nomeUf, res.data.uf);
			})
			.catch((_err) => { console.error(_err); });
	}

	return formatCepInput(input);
};

export const formatBRL = value => {
	const formatter = new Intl.NumberFormat('pt-BR', {
		style: 'currency',
		currency: 'BRL',
		minimumFractionDigits: 2
	});

	value = formatter.format(value);

	return value;
};

export const formatIntNumber = value => {
	const formatter = new Intl.NumberFormat('pt-BR', {
		style: 'decimal',
		maximumFractionDigits: 0
	});

	value = formatter.format(value);

	return value;
};

export const formatBRLInput = input => {
	input.target.value = Number(input.target.value.toString().replace(/[^0-9-]/g, '')) / 10 ** 2;

	input.target.value = formatBRL(input.target.value);

	return input;
};

export const formatCPF = value => {
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

	return value;
};

export const formatCPFInput = input => {
	input.target.value = formatCPF(input.target.value);

	return input;
};

export const formatCNPJInput = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1/$2");
	value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");

	input.target.value = value;

	return input;
};

export const formatCNPJ = value => {
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1/$2");
	value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");

	return value;
};

export const formatTelefone = value => {
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{0})(\d)/, "$1($2");
	value = value.replace(/(\d{2})(\d)/, "$1) $2");
	value = value.replace(/(\d{1})(\d{1,4})$/, "$1-$2");

	return value;
};

export const formatTelefoneInput = input => {
	input.target.value = formatTelefone(input.target.value);

	return input;
};

export const formatCep = value => {
	if (!value) return '';

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{5})(\d)/, "$1-$2");

	return value;
};

export const formatCepInput = input => {
	input.target.value = formatCep(input.target.value);

	return input;
};

// Insere o traço do dígito verificador antes do último número digitado, caso a
// pessoa digite só os números (ex: "7615886032" vira "761588603-2"). Se já tiver
// traço (inclusive dígito verificador alfanumérico, ex: "12345-X"), não mexe.
export const formatAccountInput = input => {
	let value = input.target.value;

	if (!value.includes('-')) {
		value = value.replace(/\D/g, "");

		if (value.length >= 2) {
			value = value.slice(0, -1) + "-" + value.slice(-1);
		}
	}

	input.target.value = value;

	return input;
};

export const limparMoeda = (valor) => {
	// A API pode devolver number/false/null no lugar do valor formatado; só string precisa de limpeza.
	if (typeof valor !== 'string') return valor;

	valor = valor.replace("R$", "");
	valor = valor.replaceAll(".", "");
	valor = valor.replace(",", ".");
	valor = valor.trim();

	return valor;
};

export const toAmount = (value) => {
	const parsed = Number(limparMoeda(value));

	return Number.isFinite(parsed) ? Number(parsed.toFixed(2)) : 0;
};

export const limparCPF = (valor) => {
	valor = valor.replaceAll(".", "");
	valor = valor.replace("-", "");
	valor = valor.replace('/^{Z}+|{Z}+$/u', '');
	valor = valor.trim();

	return valor;
};

export const limparCNPJ = (valor) => {
	valor = valor.replaceAll(".", "");
	valor = valor.replace("-", "");
	valor = valor.replace("/", "");
	valor = valor.replace('/^{Z}+|{Z}+$/u', '');
	valor = valor.trim();

	return valor;
};

export const limparMoedaFunction = (valor) => {
	valor = valor.replace(/[^0-9,]*/g, '').replace(',', '.');

	valor = valor.trim();

	if (valor == '') return 0;

	return valor;
};

export const formatBRLNoSign = (value) => {
	const formatter = new Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: "BRL",
		symbol: "",
	});

	value = formatter.format(value).replace("R$", "");

	return value;
};

export const limparTelefone = (valor) => {
	valor = valor.replaceAll("(", "");
	valor = valor.replaceAll(")", "");
	valor = valor.replaceAll("-", "");
	valor = valor.replaceAll(" ", "");
	valor = valor.replace('/^{Z}+|{Z}+$/u', '');
	valor = valor.trim();

	return valor;
};

export const getImovelTipoName = (type) => {
	switch (type) {
		case 'apartment':
			return 'Apartamento';
		case 'house':
			return 'Casa';
		case 'Casa':
			return 'Casa';
		case 'studio':
			return 'Studio';
		case 'condo_house':
			return 'Casa em condomínio';
		case 'penthouse':
			return 'Cobertura';
		default:
			return '';
	}
};

export const getTypesOfAnnouncements = () => {
	return [
		{ label: "Casa", value: "house" },
		{ label: "Casa em condomínio", value: "condo_house" },
		{ label: "Kitnet/studio", value: "studio" },
		{ label: "Cobertura", value: "penthouse" },
		{ label: "Apartamento", value: "apartment" },
	];
};

export const isEmpty = (item) => {
	const type = (item) ? item.constructor.name.toLowerCase() : false;
	return !(
		(type === 'bollean') ||
		((type === 'array' || type === 'string') && item?.length) ||
		(type === 'object' && Object.keys(item).length)
	);
}

export function bytesToSize(bytes) {
	const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
	const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
	return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
}

// Titulo da aba: "Mellro - <contexto>", caindo para "Mellro" enquanto o dado nao carregou
export function setPageTitle(context) {
	document.title = context ? `Mellro - ${context}` : 'Mellro';
}

export const getStates = () => {
	return [
		"AC",
		"AL",
		"AP",
		"AM",
		"BA",
		"CE",
		"DF",
		"ES",
		"GO",
		"MA",
		"MT",
		"MS",
		"MG",
		"PA",
		"PB",
		"PR",
		"PE",
		"PI",
		"RJ",
		"RN",
		"RS",
		"RO",
		"RR",
		"SC",
		"SP",
		"SE",
		"TO",
	];
};

export const getProfessions = async () => {
	const instance = axios.create();

	const response = await instance
		.get(`https://dev-api.mellro.com/api/occupations/all`)
		.then((res) => {
			return res.data.data
		})
		.catch((err) => {
			console.log(err);
		});

	return response;
}

export const getLegalNatures = async () => {
	const instance = axios.create();

	const response = await instance
		.get(`https://dev-api.mellro.com/api/legal-natures/all`)
		.then((res) => {
			return res.data.data
		})
		.catch((err) => {
			console.log(err);
		});

	return response;
}

export const getDeclaredIncomes = async () => {
	const instance = axios.create();

	const response = await instance
		.get(`https://dev-api.mellro.com/api/declared-incomes/all`)
		.then((res) => {
			return res.data.data
		})
		.catch((err) => {
			console.log(err);
		});

	return response;
}

export const getBusinessTypes = async () => {
	const instance = axios.create();

	const response = await instance
		.get(`https://dev-api.mellro.com/api/business-types/all`)
		.then((res) => {
			return res.data.data
		})
		.catch((err) => {
			console.log(err);
		});

	return response;
}

export const getReasonAccountRefused = (reason) => {
	switch (reason) {
		case 'NOT_RETRY':
			return `Indica que o CPF do cadastro já recebeu alguma marcação de fraude pelo nosso time de Prevenção e foi bloqueado.
					Por isso, não é possível abrir uma nova conta para esse CPF fraudado.`;
		case 'NOT_ALLOWED':
			return 'Indica que o parceiro está fazendo a chamada em algum endpoint ao qual não tem acesso por razões contratuais.';
		case 'SELFIE_RECUSED':
			return 'A selfie enviada apresenta problemas relativos à prova de vida.';
		case 'DOCUMENT_RECUSED':
			return `Há problemas na comparação da foto do documento do cliente com a imagem da selfie enviada,
			não sendo possível confirmar que se trata da mesma pessoa.`;
		case 'OCR_RECUSED':
			return `Existem divergências entre as informações retornadas pela leitura do documento e as informações fornecidas pelo cliente.`;
		case 'AGE_RECUSED':
			return `Existem divergências entre a data de nascimento informada pelo cliente e a verificada nos bureaus de informação.
			Esse status também retorna em caso de tentativa de cadastro de menores de 16 anos.`;
		case 'NAME_RECUSED':
			return `Há problemas relativos à comparação do nome do cliente ou da mãe, fornecidos por escrito no aplicativo, com os retornados pelo bureau e OCR.`;
		case 'STATUS_RECUSED':
			return `Há problemas relativos ao CPF informado no cadastro.`;
		case 'EMAIL_RECUSED':
			return `Foi detectada fraude relacionada ao e-mail informado pelo cliente.`;
		case 'FORBIDDEN_WORDS':
			return `Foi detectada alguma palavra de cunho ofensivo ou de baixo calão.`;
		case 'RISKY_BEHAVIOR':
			return `Indica alto risco de fraude associado ao cadastro realizado.`;
		case 'NOT_FOUND':
			return `As informações do cliente não foram localizadas nos bureaus.
			Esse cenário é mais comum para menores de idade e pessoas que completaram 18 anos recentemente.`;
		case 'DATA_RECUSED':
			return `Há problemas com os dados informados pelo cliente, quando comparados com aqueles obtidos via bureau.
			Os dados podem ser: nome, nome da mãe, data de nascimento, situação do CPF junto à Receita Federal, nome da empresa e CPF não pertencente ao QSA (quadro de sócios e administradores).
			Observação: Devido ao caráter genérico desse status, futuramente ele será descontinuado.`;
		case 'PHOTO_RECUSED':
			return `Problema relacionado à imagem da selfie ou do documento.
			No caso da selfie, é possível que ela não esteja permitindo a identificação clara do cliente ou que aparente ser a foto de um retrato ou tela.
			Observação: Devido ao caráter genérico desse status, futuramente ele será descontinuado.`;
		default:
			return '';
	}
};

export const getReasonAccountRefusedWhatToDo = (reason) => {
	switch (reason) {
		case 'NOT_RETRY':
			return `Não é possível realizar o cadastro desse cliente.
			Interrompa as tentativas de cadastro desse CPF.`;
		case 'NOT_ALLOWED':
			return 'Entre em contato com seu representante comercial.';
		case 'SELFIE_RECUSED':
			return `Instrua seu cliente a tirar a selfie em um local bem iluminado e não utilizar acessórios, como bonés, óculos de sol etc.
					Recomendamos adicionar uma máscara na tela para orientar o local em que o usuário deve posicionar o rosto no momento da captura da foto.
					Após a foto ser tirada, exiba o resultado para que o usuário a aprove. Caso não haja aprovação, ofereça a opção de tirar nova foto.`;
		case 'DOCUMENT_RECUSED':
			return `Recomende que a foto contenha apenas a imagem do documento, sem interferência de fundo, e que esteja bem enquadrada.
			Se possível, a foto deve ser tirada com o documento fora do plástico.`;
		case 'OCR_RECUSED':
			return `O documento fotografado deve ser RG ou CNH.
					Recomende que a foto contenha apenas a imagem do documento, sem interferência de fundo, e que esteja bem enquadrada.
					Se possível, a foto deve ser tirada com o documento fora do plástico.`;
		case 'AGE_RECUSED':
			return `Solicite que o cliente confira os dados fornecidos, pois eles devem estar de acordo com os informados no documento enviado.
					Não permita que clientes menores de 16 anos realizem o cadastro.`;
		case 'NAME_RECUSED':
			return `Peça a seu cliente que confirme os dados fornecidos, pois eles devem estar de acordo com os informados no documento enviado.
					Recordamos que o problema pode referir-se à alteração do nome do cliente por estado civil (nome de solteiro x nome de casado) que não foi atualizado nos sistemas públicos de registro.`;
		case 'STATUS_RECUSED':
			return `Verifique o status do CPF de seu cliente junto à Receita Federal.
					Se necessário, solicite que ele regularize sua situação.
					Caso verificado que a situação de seu cliente é regular, entre em contato com o Service Desk do Bankly.`;
		case 'EMAIL_RECUSED':
			return `Não é possível realizar o cadastro desse cliente.`;
		case 'FORBIDDEN_WORDS':
			return `Solicite que o cliente reenvie os dados, atentando-se ao teor das palavras.`;
		case 'RISKY_BEHAVIOR':
			return `Não é possível realizar o cadastro desse cliente.`;
		case 'NOT_FOUND':
			return `Entre em contato com o Service Desk do Bankly.`;
		case 'DATA_RECUSED':
			return `Solicite ao cliente que envie os dados novamente com base no detalhamento dos status.`;
		case 'PHOTO_RECUSED':
			return `Recomende ao seu cliente que a selfie seja tirada a uma certa distância da câmera, para que se possa obter informações do plano de fundo.
					Os documentos fotografados devem ser RG ou CNH. A câmera deve estar próxima ao documento, para facilitar a análise da face do cliente.
					Em todos os casos, é importante atentar-se ao enquadramento e à iluminação.`;
		default:
			return '';
	}
};

export const findPessoalInformation = (texto) => {
	if (!texto || texto === '') {
		return false;
	}

	const regexEmail = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/;
	const regexCPF = /\b\d{3}[\.\-]?\d{3}[\.\-]?\d{3}[\.\-]?\d{2}\b/;
	const regexCNPJ = /\b\d{2}[\.\-\/]?\d{3}[\.\-]?\d{3}[\.\-\/]?\d{4}[\.\-]?\d{2}\b|\b\d{14}\b/;
	const regexTelefone = /\b(?:\(\d{2}\)\s*|\d{2}\s*)?9?\d{4}-?\d{4}\b/;

	const matchCPF = texto.match(regexCPF);
	const cpfValido = matchCPF ? matchCPF.some(cpf => validaCpf(cpf.replace(/\D/g, ''))) : false;

	const matchCNPJ = texto.match(regexCNPJ);
	const cnpjValido = matchCNPJ ? matchCNPJ.some(cnpj => validaCnpj(cnpj.replace(/\D/g, ''))) : false;

	return (
		regexEmail.test(texto) ||
		cpfValido ||
		cnpjValido ||
		regexTelefone.test(texto)
	);
}

export const validaCnpj = (cnpj) => {
	cnpj = cnpj.replace(/[^\d]+/g, '');

	if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

	const calcularDigito = (base, pesos) => {
		let soma = 0;
		for (let i = 0; i < pesos.length; i++) {
			soma += parseInt(base.charAt(i)) * pesos[i];
		}
		let resto = soma % 11;
		return resto < 2 ? 0 : 11 - resto;
	};

	const base = cnpj.slice(0, 12);
	const primeiroDigito = calcularDigito(base, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
	const segundoDigito = calcularDigito(base + primeiroDigito, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

	return primeiroDigito === parseInt(cnpj.charAt(12)) && segundoDigito === parseInt(cnpj.charAt(13));
};

export const validaCpf = (cpf) => {
	var add = 0;
	var rev = 0;

	cpf = cpf.replace(/[^\d]+/g, '');
	if (cpf == '') return false;

	if (cpf.length != 11) return false;

	for (var i = 0; i < 9; i++) {
		add += parseInt(cpf.charAt(i)) * (10 - i);
	}

	rev = 11 - (add % 11);

	if (rev == 10 || rev == 11) {
		rev = 0;
	}
	if (rev != parseInt(cpf.charAt(9))) {
		return false;
	}

	add = 0;

	for (i = 0; i < 10; i++) {
		add += parseInt(cpf.charAt(i)) * (11 - i);
	}

	rev = 11 - (add % 11);

	if (rev == 10 || rev == 11) {
		rev = 0;
	}

	if (rev != parseInt(cpf.charAt(10))) {
		return false;
	}
	return true;
}

export const getExtraDocumentType = (type) => {
	switch (type) {
		case 'CUSTOM':
			return 'Documento extra';
		case 'SOCIAL_CONTRACT':
			return 'Contrato social';
		case 'LIMITED_COMPANY':
			return 'Companhia limitada';
		case 'ENTREPRENEUR_REQUIREMENT':
			return 'Requerimento de empresário';
		case 'MINUTES_OF_ELECTION':
			return 'Minutos da eleição';
		default:
			return 'Documento extra';
	}
}

export const getStatusAnticipations = (status) => {
	switch (status) {
		case 'PENDING_SIGN':
			return <BetterTag type="warning">Assinatura pendente</BetterTag>;
		case 'EXPIRED':
			return <BetterTag type="danger">Cancelado</BetterTag>;
		case 'SIGNED':
			return <BetterTag type="info">Assinado</BetterTag>;
		default:
			return <BetterTag type="neutral">Sem status</BetterTag>;
	}
}

export const formatFullName = (name) => {
	if (!name) return '';

	return name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
}

export const getPixKeyType = (value) => {
	if (!value) return '--';

	// Email
	if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) || value === 'EMAIL') {
		return 'E-mail';
	}

	// Chave aleatória (UUID v4)
	if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value) || value === 'EVP') {
		return 'Chave aleatória';
	}

	// CNPJ
	if (/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/i.test(value) || /^\d{14}$/.test(value) || value === 'CNPJ') {
		return 'CNPJ';
	}

	// Telefone (aceita com ou sem máscara)
	if (/^\d{11}$/.test(value) || /^\(\d{2}\)\s?\d{4,5}-\d{4}$/.test(value) || value === 'PHONE') {
		// Verifica se pode ser CPF válido
		if (validaCpf && validaCpf(value)) {
			return 'CPF';
		}
		return 'Celular com DDD';
	}

	// CPF (com ou sem máscara)
	if (/^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(value) || /^\d{11}$/.test(value) || value === 'CPF') {
		return 'CPF';
	}

	// Fallback
	return '--';
};

export const getAnalysisStatusAnticipations = (analysis_status, anticipation_status) => {
	if (anticipation_status == "PENDING_SIGN") {
		return <BetterTag type="warning">Assinatura pendente</BetterTag>;
	}

	switch (analysis_status) {
		case 'PENDING':
			return <BetterTag type="warning">Pendente</BetterTag>;
		case 'REJECTED':
			return <BetterTag type="danger">Rejeitada</BetterTag>;
		case 'APPROVED':
			return <BetterTag type="success">Aprovada</BetterTag>;
		default:
			return <BetterTag type="neutral">Sem status</BetterTag>;
	}
}

export const floor2 = (num) => Math.floor(num * 100) / 100;

export const formatBRLWithDots = (value) => {
	const formatter = new Intl.NumberFormat('pt-BR', {
		style: 'currency',
		currency: 'BRL',
		minimumFractionDigits: 2
	});

	value = formatter.format(value).replace(',', '.');

	return value;
}

export const statesForCrawler = [
	{ label: 'Acre', value: 'ac' },
	{ label: 'Alagoas', value: 'al' },
	{ label: 'Amapá', value: 'ap' },
	{ label: 'Amazonas', value: 'am' },
	{ label: 'Bahia', value: 'ba' },
	{ label: 'Ceará', value: 'ce' },
	{ label: 'Distrito Federal', value: 'df' },
	{ label: 'Espírito Santo', value: 'es' },
	{ label: 'Goiás', value: 'go' },
	{ label: 'Maranhão', value: 'ma' },
	{ label: 'Mato Grosso', value: 'mt' },
	{ label: 'Mato Grosso do Sul', value: 'ms' },
	{ label: 'Minas Gerais', value: 'mg' },
	{ label: 'Pará', value: 'pa' },
	{ label: 'Paraíba', value: 'pb' },
	{ label: 'Paraná', value: 'pr' },
	{ label: 'Pernambuco', value: 'pe' },
	{ label: 'Piauí', value: 'pi' },
	{ label: 'Rio de Janeiro', value: 'rj' },
	{ label: 'Rio Grande do Norte', value: 'rn' },
	{ label: 'Rio Grande do Sul', value: 'rs' },
	{ label: 'Rondônia', value: 'ro' },
	{ label: 'Roraima', value: 'rr' },
	{ label: 'Santa Catarina', value: 'sc' },
	{ label: 'São Paulo', value: 'sp' },
	{ label: 'Sergipe', value: 'se' },
	{ label: 'Tocantins', value: 'to' },
]

export const isDevEnvironment = () => {
	const currentUrl = window.location.href;

	const localEnvironment = currentUrl.toLowerCase().includes('localhost');
	const devEnvironment = currentUrl.toLowerCase().includes('dev-admin');
	const homologEnvironment = currentUrl.toLowerCase().includes('homolog-admin');

	if (localEnvironment || devEnvironment || homologEnvironment) {
		return true;
	}

	return false;
}

export const getMellroAppUrl = () => {
	const host = (typeof window !== 'undefined' ? window.location.host : '').toLowerCase();

	if (host.includes('homolog-admin')) return 'https://homolog-app.mellro.com';
	if (host.includes('localhost') || host.includes('dev-admin')) return 'https://dev-app.mellro.com';

	return 'https://mellro.com';
}

export const getWarranty = (key) => {
	switch (key) {
		case 'WARRANTY':
			return 'Pagamento';
		case 'WARRANTY_GUARANTEE_DAMAGE':
			return 'Completa';
		default:
			return 'Não identificada';
	}
};

export const getStatusProposition = (obj) => {
	let status = '';
	let backgroundColor = 'var(--ui-info)'

	switch (obj?.status) {
		case 'PLACEHOLDER':
			status = 'Chat iniciado';
			backgroundColor = 'var(--ui-info)';
			break;
		case 'DRAFT':
			status = 'Criada integrações';
			backgroundColor = 'var(--ui-purple)';
			break;
		case 'AWAITING_TENANT_LOCK':
			status = 'Aguardando trava inquilino';
			backgroundColor = 'var(--ui-purple)';
			break;
		case 'AWAITING_CREDIT_REVIEW':
			status = 'Aguardando análise financeira';
			backgroundColor = '#EFA200';
			break;
		case 'APPROVED':
			status = 'Análise financeira aprovada';
			backgroundColor = 'var(--ui-success)';
			break;
		case 'FIRST_PROPOSAL':
			status = 'Criada Admin';
			backgroundColor = 'var(--ui-purple)';
			break;
		case 'CREDIT_REFUSED':
			status = 'Análise financeira reprovada';
			backgroundColor = 'var(--ui-danger)';
			break;
		case 'AWAITING_SIGN':
			status = 'Aguardando assinatura de contrato';
			backgroundColor = '#EFA200';
			break;
		case 'FINALIZED':
			status = 'Contrato Vigente';
			backgroundColor = 'var(--ui-success)';
			break;
		case 'FINISHED':
			status = 'Contrato encerrado';
			backgroundColor = 'var(--ui-purple)';
			break;
		default:
			status = obj?.status;
			break;
	}

	return <BetterTag color={backgroundColor}>{status}</BetterTag>;
};

export const getOrigensRenda = () => {
	return [
		{ key: 'clt', label: 'Funcionário Privado ou Público Registrado (CLT)' },
		{ key: 'public_agent', label: 'Funcionário Público (Estatutário)' },
		{ key: 'legal_person', label: 'Empresário' },
		{ key: 'liberal_professional', label: 'Profissional liberal' },
		{ key: 'autonomous', label: 'Autônomo' },
		{ key: 'retired', label: 'Aposentado ou Pensionista' },
		{ key: 'intern', label: 'Estagiário ou Bolsista' },
	];
};

export const getClientClassifications = () => {
	return [
		{ key: false, label: 'Não' },
		{ key: true, label: 'Sim' },
	];
};

export const getCompanySectors = () => {
	return [
		{ key: 'COMERCIAL', label: 'Comercial' },
		{ key: 'MARKETING', label: 'Marketing' },
		{ key: 'PROTECAO_RECEITA', label: 'Proteção de Receita' },
		{ key: 'TECH_SUPPORT', label: 'Tech Support' },
		{ key: 'PRODUTO_TECNOLOGIA', label: 'Produto e tecnologia' },
		{ key: 'PEOPLE_PARTNERS', label: 'People & Partners' },
		{ key: 'ADMINISTRATIVO', label: 'Administrativo' },
		{ key: 'FINANCEIRO', label: 'Financeiro' },
		{ key: 'INVESTIMENTOS', label: 'Investimentos' },
		{ key: 'OPERACOES_ESTRATEGICAS', label: 'Operações Estratégicas' },
		{ key: 'OUTRO', label: 'Outro' },
	];
};

// Rótulos amigáveis para chaves de company_sector removidas da lista atual,
// usados só para exibir corretamente o valor salvo de usuários legados.
export const LEGACY_COMPANY_SECTOR_LABELS = {
	GESTAO_PESSOAS: 'Gestão de Pessoas',
	JURIDICO: 'Jurídico',
	NEGOCIACAO: 'Negociação',
	PRODUTO: 'Produto',
	SUPORTE_CS_OPERACIONAL: 'Suporte, CS e Operacional',
};

// Retorna a lista canônica de Setor, acrescentando um item de fallback
// quando currentValue não pertence à lista canônica, para não deixar o select em branco
export const getCompanySectorOptions = (currentValue) => {
	const sectors = getCompanySectors();

	if (!currentValue || sectors.some((sector) => sector.key === currentValue)) {
		return sectors;
	}

	return [
		...sectors,
		{ key: currentValue, label: LEGACY_COMPANY_SECTOR_LABELS[currentValue] || currentValue },
	];
};

// Retorna a porcentagem do Plano
export const getPlanPercentage = (plan) => {
	if (!plan) return '';

	if (Number(plan?.custom_percentage) > 0) {
		return Number(plan.custom_percentage) / 100;
	}

	if (plan?.type === 'WARRANTY' || plan?.name === 'WARRANTY') {
		return 0.07;
	}

	return 0.10;
};


// Retorna o valor real do Imóvel subtraindo o valor da Mellro
export const getNetRent = (totalRent, plan, coupon) => {
	let percentage = getPlanPercentage(plan);

	if (coupon) {
		percentage = percentage - (coupon?.discountValue / 100);
	}

	const netRent = totalRent - (totalRent * percentage);

	return netRent;
}

export const getContractAddress = (contract) => {
	const address = contract?.proposition?.announcement?.address
		|| contract?.announcement?.address
		|| contract?.address;

	if (!address) return null;

	const parts = [];
	if (address.street) parts.push(`${address.street}${address.number ? `, ${address.number}` : ''}`);
	if (address.neighbourhood) parts.push(address.neighbourhood);
	if (address.city && address.state) parts.push(`${address.city} - ${address.state}`);
	else if (address.city) parts.push(address.city);

	return parts.join(', ') || null;
};

export const getNomeNegociacao = (participantUsers, address) => {
	let text = '';

	participantUsers?.forEach((participante, index) => {
		const firstName = participante.name.split(' ')[0];
		const isLast = index + 1 === participantUsers.length;

		if (text === '') {
			text = firstName;
		} else if (isLast) {
			text = text + ' e ' + firstName;
		} else {
			text = text + ', ' + firstName;
		}
	});

	text = text + ` em ${address?.neighbourhood ? `${address?.neighbourhood},` : ''} ${address?.city} - ${address?.state}`;

	return text;
};

export const BILLING_TYPES = ['Fatura de aluguel', 'Fatura rescisória', 'Fatura de danos'];

export const RESCISSION_SUBCATEGORIES = ['Devolução de garantia', 'Multas rescisórias'];

export const USER_TYPE_LABELS = {
	tenant: 'Inquilino',
	landlord: 'Responsável',
	admin: 'Responsável',
	commissioned: 'Comissionado',
};

export const isRentBillingType = (billingType) => billingType === 'Fatura de aluguel' || billingType === 'Aluguel';

export const isRescissionBillingType = (billingType) => billingType === 'Fatura rescisória';

export const isBillingWarranted = (billing) => Boolean(
	billing?.payment_warranted === true || billing?.receipts?.rent?.paid_for_insurer === true
);

export const isFriendlyAgreementAlive = (agreementId, friendlyAgreements) => {
	if (!agreementId) return false;
	if (!friendlyAgreements) return true;

	const agreement = friendlyAgreements.find((item) => item.id === agreementId);

	return Boolean(agreement) && !agreement.deleted_at && agreement.status !== 'expired';
};

// Função que unifica as TAGS DOS BILLINGS
export const getBillingStatusTag = (billing, options = {}) => {
	const { isContractAnnulled = false, friendlyAgreements } = options;

	const { rent } = billing?.receipts ?? {};
	const isRepurchased = billing?.fidc_status === 'REPURCHASED';
	const isOverdue = dayjs().format('YYYY-MM-DD') > dayjs(billing?.due_date).add(3, 'hours').format('YYYY-MM-DD');

	let statusTag = null;

	if (billing?.annulled) {
		statusTag = <BetterTag color="#5A5A5A">Anulado</BetterTag>;
	} else if (isFriendlyAgreementAlive(rent?.agreement_id, friendlyAgreements) || rent?.agreement_settled) {
		statusTag = (
			<BetterTag type={rent?.agreement_settled ? 'success' : 'info'}>
				{rent?.agreement_settled ? 'Acordo quitado' : 'Acordo vigente'}
			</BetterTag>
		);
	} else if (billing?.type === 'monthly' && billing?.termination_id) {
		statusTag = <BetterTag color="var(--ui-purple)">Acerto de rescisão</BetterTag>;
	} else if (billing?.receipts?.blocked) {
		statusTag = <BetterTag color="#FF383C">Bloqueado</BetterTag>;
	} else if (rent?.paid === true) {
		statusTag = <BetterTag type="success">Pago</BetterTag>;
	} else if (isOverdue) {
		statusTag = <BetterTag type="danger">Atrasado</BetterTag>;
	} else if (billing?.boleto?.pdf_url) {
		statusTag = (
			<>
				<BetterTag type="warning">Em aberto</BetterTag>

				{isContractAnnulled && (
					<BetterTag color="#5A5A5A">Anulado</BetterTag>
				)}
			</>
		);
	} else if (!isRepurchased) {
		statusTag = <BetterTag type="muted">Aguardando</BetterTag>;
	}

	return (
		<>
			{statusTag}

			{isBillingWarranted(billing) && (
				<BetterTag type="info">Garantido</BetterTag>
			)}

			{billing?.anticipated && (
				<BetterTag color="var(--ui-purple)">Antecipado</BetterTag>
			)}

			{billing?.contract_stop_guarantee && (
				<BetterTag type="dark-red">Garantias parada</BetterTag>
			)}

			{billing?.fidc_status === 'RECEIVED' && (
				<BetterTag type="success">Cedido</BetterTag>
			)}

			{billing?.fidc_status === 'AGUARDANDO_FIDC' && (
				<BetterTag type="warning">Aguardando FIDC</BetterTag>
			)}

			{billing?.fidc_status === 'LIQUIDATED' && (
				<BetterTag type="primary">Liquidado</BetterTag>
			)}

			{isRepurchased && (
				<BetterTag type="primary">Recomprado</BetterTag>
			)}
		</>
	);
};

export const buildBillingTypeForPayload = (billingType, rescissionSubcategory) => {
	if (isRescissionBillingType(billingType) && rescissionSubcategory) {
		return `${billingType} - ${rescissionSubcategory}`;
	}

	return billingType;
};

export const getTotalGrossGuaranteed = ({ values, tenant_pays } = {}) => {
	if (!values?.rent) return 0;

	return (
		parseFloat(values.rent) +
		(tenant_pays?.iptu ? parseFloat(values?.iptu ?? 0) : 0) +
		(tenant_pays?.condo ? parseFloat(values?.condo ?? 0) : 0)
	);
};

export const getContractParties = (contract) => {
	const users = contract?.contract_users;
	if (!Array.isArray(users)) {
		return [];
	}

	const validUsers = users.filter((cu) => cu && cu.user_id);
	const hasAdmin = validUsers.some((cu) => cu.user_type === 'admin');

	const resolveTypeLabel = (userType) => {
		if (userType === 'landlord' && hasAdmin) {
			return 'Proprietário';
		}
		return USER_TYPE_LABELS[userType] || userType;
	};

	return validUsers.map((cu) => ({
		user_id: cu.user_id,
		name: cu.name || cu.user_id,
		user_type: cu.user_type,
		label: `${cu.name || cu.user_id}${cu.user_type ? ` - ${resolveTypeLabel(cu.user_type)}` : ''}`,
	}));
};


export const safeParseJSON = (key, fallback = null) => {
	try {
		const raw = localStorage.getItem(key);
		if (raw === null) return fallback;
		return JSON.parse(raw);
	} catch (_e) {
		return fallback;
	}
};

export const safeSetItem = (key, value) => {
	try {
		localStorage.setItem(key, value);
	} catch (_e) {
		// QuotaExceededError ou SecurityError — falha silenciosa
	}
};

export const safeGetItem = (key) => {
	try { return localStorage.getItem(key); } catch (_e) { return null; }
};

export const createCancelSource = () => axios.CancelToken.source();
export const isCancelError = (err) => axios.isCancel(err);

export const formatDateCell = (date) => (
	<p>{date ? dayjs(date).add(3, 'hours').format('DD/MM/YYYY') : '-'}</p>
);

export const currencyCell = (value, align = 'end') => (
	<div style={{ textAlign: align }}>
		<p>{formatBRL(value || 0)}</p>
	</div>
);

const downloadFile = ({ content, filename, mimeType }) => {
	const blob = new Blob([content], { type: mimeType });
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(url);
};

export const downloadCSV = (csvContent, filename = 'data.csv') => {
	downloadFile({ content: csvContent, filename, mimeType: 'text/csv;charset=utf-8;' });
};

export const downloadJSON = (jsonContent, filename = 'data.json') => {
	downloadFile({ content: JSON.stringify(jsonContent, null, 2), filename, mimeType: 'application/json;charset=utf-8;' });
};

export const getDocumentTypeLabel = (type) => {
	switch ((type || '').toLowerCase()) {
		case 'cnh': return 'CNH';
		case 'rg': return 'RG';
		case 'rne': return 'RNE';
		case 'ctps': return 'CTPS';
		case 'passport': return 'Passaporte';
		case 'crlv': return 'CRLV';
		default: return type ? type.toUpperCase() : 'Documento';
	}
}
// ===== Réguas de cobrança =====

export const COLLECTION_RULER_LABELS = {
	1: 'Régua 1 - Padrão',
	2: 'Régua 2 - Escalada',
};

export const COLLECTION_RULER_STATUS_LABELS = {
	ativa: 'Ativa',
	pausada_acordo: 'Pausada por acordo',
	regularizado: 'Regularizado',
	encerrada: 'Encerrada',
};

export const COLLECTION_RISK_CRITERIA_LABELS = {
	uf: 'Estado de risco',
	fidc: 'FIDC',
	ticket_medio: 'Ticket acima de R$ 5.000',
	acordo: 'Acordo vigente',
	qtd_atraso: '2+ aluguéis em atraso',
};

export const COLLECTION_RULER_EVENT_LABELS = {
	classificacao: 'Classificação',
	migracao: 'Migração de régua',
	disparo: 'Disparo',
	disparo_cancelado: 'Disparo cancelado',
	disparo_adiado: 'Disparo adiado',
	pagamento_parcial: 'Pagamento parcial',
	quitacao: 'Quitação',
	acordo_criado: 'Acordo criado',
	acordo_atrasado: 'Acordo em atraso',
	negativacao: 'Negativação',
	baixa: 'Baixa da negativação',
	pausa: 'Pausa',
	retomada: 'Retomada',
	tarefa_juridica: 'Tarefa (humana/jurídica)',
};

export const getCollectionRulerTag = (ruler) => {
	if (ruler?.ruler === 2) return <BetterTag color="#FF383C">Régua 2</BetterTag>;

	return <BetterTag type="info">Régua 1</BetterTag>;
};

export const getCollectionRulerStatusTag = (ruler) => {
	switch (ruler?.status_regua) {
		case 'regularizado': return <BetterTag type="success">Regularizado</BetterTag>;
		case 'pausada_acordo': return <BetterTag color="var(--ui-purple)">Pausada por acordo</BetterTag>;
		case 'encerrada': return <BetterTag type="muted">Encerrada</BetterTag>;
		default: return <BetterTag type="info">Ativa</BetterTag>;
	}
};

// Dias corridos desde o D0 da régua atual.
export const getCollectionRulerDaysInRuler = (ruler) => {
	if (!ruler?.d0_date) return null;

	return dayjs().startOf('day').diff(dayjs(ruler.d0_date).startOf('day'), 'day');
};

export const TERMINATION_EDIT_ROLE = 'rescisao_editar';

// Ordem do array = ordem do grid de 2 colunas da box de valores.
export const TERMINATION_EDITABLE_FIELDS = [
	{ key: 'termination_fine', field: 'multaRescisoria', label: 'Multa rescisória', requiresRole: false, capped: true },
	{ key: 'contract_violation_fine', field: 'multaQuebraContratual', label: 'Multa quebra contratual', requiresRole: false, capped: true },
	{ key: 'rent_enjoyed', field: 'aluguelUsufruido', label: 'Aluguel usufruído', requiresRole: true, capped: false },
	{ key: 'repayments', field: 'reembolso', label: 'Reembolsos', requiresRole: false, capped: false, signAgnostic: true },
	{ key: 'current_rent', field: 'mesVigente', label: 'Mês vigente', requiresRole: true, capped: false },
	{ key: 'overdue_payments', field: 'atrasosMellro', label: 'Atrasos Mellro', requiresRole: true, capped: false }
];

export const getAuthUser = () => {
	try {
		return JSON.parse(localStorage.getItem('authUser'))?.user ?? null;
	} catch (e) {
		return null;
	}
};

export const hasTerminationEditRole = (user) => Array.isArray(user?.roles) && user.roles.includes(TERMINATION_EDIT_ROLE);

export const hasCouponFreeDiscountRole = (user) => Array.isArray(user?.roles) && user?.roles?.includes('cupom_desconto_livre');

export const hasUserNotificationsPauseRole = (user) => Array.isArray(user?.roles) && user.roles.includes('pause_user_notifications');

export const isNotificationSuppressedByUser = (notification) => notification?.suppressed_reason === 'USER_NOTIFICATIONS_DISABLED';

// Assinatura (user, key) para a fase 2 trocar só esta implementação por permissão granular.
export const canEditTerminationField = (user, key) => {
	const field = TERMINATION_EDITABLE_FIELDS.find(item => item.key === key);

	if (!field) return false;

	return field.requiresRole ? hasTerminationEditRole(user) : true;
};

export const isTerminationFieldCapped = (user, key) => {
	const field = TERMINATION_EDITABLE_FIELDS.find(item => item.key === key);

	if (!field) return false;

	return field.capped && !hasTerminationEditRole(user);
};

// Link curto da Mellro (mellro.com/s/<codigo>), o unico formato que tem rastreio de cliques.
const MELLRO_SHORT_LINK_REGEX = /^https?:\/\/(?:dev-app\.|homolog-app\.)?mellro\.com\/s\/([a-zA-Z0-9]+)$/;

export const getShortLinkCode = (url) => (
	typeof url === 'string' ? (url.match(MELLRO_SHORT_LINK_REGEX)?.[1] ?? null) : null
);

// Le o link da notificacao dos campos que o payload de fato usa. Nao varrer o payload em busca
// de qualquer /s/: ele embute os objetos de usuario, e affiliate_link tambem casa com esse
// formato, fazendo o admin exibir o link de afiliado no lugar do link da notificacao.
export const getNotificationLink = (notificationData) => {
	const isUrl = (value) => typeof value === 'string' && /^https?:\/\//.test(value);

	const direct = [
		notificationData?.shortLink,
		notificationData?.link,
		notificationData?.url,
		notificationData?.context,
	].find(isUrl);

	if (direct) return direct;

	// whatsapp entrega as variaveis do template num array
	return (notificationData?.variables ?? []).find(isUrl) ?? null;
};

// Postagem de vistoria ainda em rascunho: a foto foi enviada mas o item nunca foi completado (ambiente/estado).
export const isInspectionItemPending = (item) => !item?.edited;

export const getInspectionItemsMedias = (items = []) => items.flatMap(item => item?.medias ?? []);

export const getInspectionLastUpdate = (items = []) => items.reduce((last, item) => {
	if (!item?.submitted_at) return last;

	return !last || dayjs(item.submitted_at).isAfter(last) ? item.submitted_at : last;
}, null);

// Sem $select a query traz os JSONB (data, channel_metadata), que dominam o tempo da consulta.
export const NOTIFICATION_LIST_FIELDS = [
	'id', 'user_id', 'category', 'channel', 'title',
	'created_at', 'dispatched_at', 'delay_delivery_until',
];

// Omitir user_id aqui faz a rota pular tambem o attach-entity no auth-service.
export const USER_NOTIFICATION_LIST_FIELDS = [
	'id', 'category', 'channel', 'title', 'dispatched_at', 'updated_at', 'suppressed_reason',
];

// Asaas desativa o webhook da subconta após falhas seguidas de entrega. Sem resposta da
// Asaas o status é desconhecido, não inativo.
export const getSubaccountWebhookStatus = (webHookStatus) => {
	if (!webHookStatus) return { label: 'Indisponível', color: 'var(--ui-muted)' };

	return webHookStatus.enabled
		? { label: 'Ativo', color: 'var(--ui-success)' }
		: { label: 'Inativo', color: 'var(--ui-danger)' };
};

export const getSubaccountQueueStatus = (webHookStatus) => {
	if (!webHookStatus) return { label: 'Indisponível', color: 'var(--ui-muted)' };

	return webHookStatus.interrupted
		? { label: 'Interrompida', color: 'var(--ui-danger)' }
		: { label: 'Liberada', color: 'var(--ui-success)' };
};

export const getSubaccountBalanceColor = (balance) => (
	Number(balance) > 0 ? 'var(--ui-success)' : 'var(--ui-muted)'
);

// documentStatus vem do asaas_accounts, gravado pelo webhook de situação da conta
const ASAAS_ACCOUNT_SITUATIONS = {
	approved: { label: 'Aprovada', color: 'var(--ui-success)' },
	pending: { label: 'Em análise', color: 'var(--ui-warning)' },
	not_send: { label: 'Documentos não enviados', color: 'var(--ui-warning)' },
	rejected: { label: 'Documento recusado', color: 'var(--ui-danger)' },
	general_rejected: { label: 'Conta recusada', color: 'var(--ui-danger)' },
};

export const getAsaasAccountSituation = (accountVerification) => (
	ASAAS_ACCOUNT_SITUATIONS[accountVerification?.documentStatus]
	?? { label: 'Indisponível', color: 'var(--ui-muted)' }
);

// Anexo da revalidação que subiu pro S3 mas não chegou a virar registro na tabela de documentos.
export const isRevalidationAttachmentUnsynced = (revalidation) => (
	Boolean(revalidation?.file_uploaded) && !revalidation?.doc_user_synced
);

export const getUnsyncedRevalidationAttachments = (revalidations = []) => (
	revalidations.filter(isRevalidationAttachmentUnsynced)
);

// Categorias de caf_logs por fluxo. Um log de VP nao pode aparecer no painel de biometria e
// vice-versa: o backend ja filtra por category_in, mas o filtro e descartado em silencio se a
// rota nao declarar o parametro (stripUnknown), entao o admin refiltra do lado dele.
export const CAF_LOG_BIOMETRY_CATEGORIES = ['BIOMETRICS', 'MANUAL_BIOMETRY'];
export const CAF_LOG_PROFILE_VERIFICATION_CATEGORIES = ['PROFILE_VERIFICATION', 'MANUAL_PROFILE_VERIFICATION'];

export const filterCafLogsByCategory = (logs, categories) => (
	(logs ?? []).filter(log => categories.includes(log?.category))
);

export const TENANT_RD_ROLES = ['rd_tenant', 'rd_interested', 'cf_contexto_p_perfil_inquilino'];

// As tags de RD sao best-effort, entao negociacao/contrato tambem contam como inquilino.
export const isTenantUser = (user, { inContract = false, inProposition = false } = {}) => (
	inContract || inProposition || (user?.rd_roles ?? []).some(role => TENANT_RD_ROLES.includes(role))
);

export const getApiErrorMessage = (error, fallback) => {
	const message = error?.response?.data?.message;

	return typeof message === 'string' && message.trim() ? message : fallback;
};

export const openDocumentInNewTab = async (fetchUrl, fallbackMessage = 'Não foi possível abrir o documento.') => {
	// a aba tem que ser aberta antes do await, senão o bloqueador de popup barra
	const newTab = window.open('', '_blank');

	try {
		const url = await fetchUrl();

		if (!url) {
			throw new Error('empty document url');
		}

		if (newTab) {
			newTab.location.href = url;
		}

		return null;
	} catch (error) {
		if (newTab) {
			newTab.close();
		}

		return getApiErrorMessage(error, fallbackMessage);
	}
};

export const isPortabilityContract = (contract) => Boolean(contract?.details?.portability?.portability);

const EXTERNAL_CONTRACT_DOCUMENTS = {
	contract: { fileField: 'contractFile', hashField: 'contractHash', label: 'Upload do contrato assinado:', hashPlaceholder: 'Hash do contrato', name: 'contrato assinado' },
	aditivo: { fileField: 'aditivoFile', hashField: 'aditivoHash', label: 'Upload do aditivo de portabilidade assinado:', hashPlaceholder: 'Hash do aditivo', name: 'aditivo de portabilidade' },
	distrato: { fileField: 'distratoFile', hashField: 'distratoHash', label: 'Upload do distrato de contrato anterior assinado:', hashPlaceholder: 'Hash do distrato', name: 'distrato de contrato anterior' },
	procuracao: { fileField: 'procuracaoFile', hashField: 'procuracaoHash', label: 'Upload da procuração assinada:', hashPlaceholder: 'Hash da procuração', name: 'procuração' }
};

export const getExternalContractDocuments = (contract) => (
	(isPortabilityContract(contract) ? ['aditivo', 'distrato', 'procuracao'] : ['contract', 'procuracao'])
		.map(key => ({ key, ...EXTERNAL_CONTRACT_DOCUMENTS[key] }))
);

export const isPdfFile = (file) => file?.type === 'application/pdf' || /\.pdf$/i.test(file?.name ?? '');

// O contract-service responde erro como { error, message, details }, com details às vezes texto
export const getContractServiceErrorMessage = (error, fallback) => {
	const body = error?.response?.data;

	if (Array.isArray(body?.details) && body.details.length > 0) {
		return body.details.map(detail => detail?.message ?? String(detail)).join('; ');
	}

	return typeof body?.message === 'string' && body.message.trim() ? body.message : fallback;
};

export const isTransientRequestError = (error) => !error?.response || error.response.status >= 500;

// Mesma regra do create-termination-billings: havendo parte da Mellro, o inquilino paga a dela e o responsável a dele.
export const getTerminationPayerLabel = (simulation) => {
	const landlordPays = simulation?.repayments?.type === 'repayment' && Number(simulation?.landlord_termination_value) > 0;
	const tenantPaysMellro = Number(simulation?.mellro_termination_value) > 0;

	if (landlordPays && tenantPaysMellro) {
		return 'Inquilino e responsável pagam';
	}

	return landlordPays ? 'Responsável paga' : 'Inquilino paga';
};

// Na rescisão retroativa a saída + 10 dias já passou, e a parcela não pode nascer vencida.
export const getTerminationFirstDueDate = (exitDate) => {
	const minimumDueDate = dayjs().add(10, 'days');
	const exitDueDate = dayjs(exitDate).add(10, 'days');

	return exitDueDate.isAfter(minimumDueDate) ? exitDueDate : minimumDueDate;
};

export const BANNER_STATUS = {
	INACTIVE: { key: 'INACTIVE', label: 'Inativo', type: 'muted' },
	SCHEDULED: { key: 'SCHEDULED', label: 'Agendado', type: 'warning' },
	EXPIRED: { key: 'EXPIRED', label: 'Expirado', type: 'danger' },
	ACTIVE: { key: 'ACTIVE', label: 'No ar', type: 'success' },
};

// Espelha o filtro do backend: só está no ar quando ativo e dentro da janela de datas
export const getBannerStatus = (banner) => {
	if (!banner?.is_active) return BANNER_STATUS.INACTIVE;

	const today = dayjs().format('YYYY-MM-DD');

	if (banner.start_date && today < banner.start_date) return BANNER_STATUS.SCHEDULED;
	if (banner.end_date && today > banner.end_date) return BANNER_STATUS.EXPIRED;

	return BANNER_STATUS.ACTIVE;
};

export const isBannerMissingImage = (banner) => !banner?.desktop_image?.url;

export const formatBannerDateRange = (banner) => {
	const start = banner?.start_date ? dayjs(banner.start_date).format('DD/MM/YYYY') : '--';
	const end = banner?.end_date ? dayjs(banner.end_date).format('DD/MM/YYYY') : 'sem fim';

	return `${start} até ${end}`;
};

// Espelha imageUpload.banners.dimensions do auth-service; mudou lá, muda aqui
export const BANNER_IMAGE_RULES = {
	aspectRatio: 2.705,
	aspectRatioTolerance: 0.04,
	desktop: { minWidth: 752, minHeight: 278 },
	mobile: { minWidth: 368, minHeight: 136 },
};

export const getBannerImageError = ({ width, height }, variant) => {
	const rules = BANNER_IMAGE_RULES[variant];

	if (!width || !height) return 'Não foi possível ler as dimensões da imagem.';

	if (width < rules.minWidth || height < rules.minHeight) {
		return `A imagem tem ${width}x${height}px e o mínimo é ${rules.minWidth}x${rules.minHeight}px.`;
	}

	const ratio = width / height;

	if (Math.abs(ratio - BANNER_IMAGE_RULES.aspectRatio) > BANNER_IMAGE_RULES.aspectRatioTolerance) {
		return `A imagem tem proporção ${ratio.toFixed(2)}:1 e o padrão dos banners é ${BANNER_IMAGE_RULES.aspectRatio}:1 (ex: ${rules.minWidth}x${rules.minHeight}px).`;
	}

	return null;
};

export const readImageDimensions = (file) => new Promise((resolve) => {
	const objectUrl = URL.createObjectURL(file);
	const image = new Image();

	image.onload = () => {
		URL.revokeObjectURL(objectUrl);
		resolve({ width: image.naturalWidth, height: image.naturalHeight });
	};

	image.onerror = () => {
		URL.revokeObjectURL(objectUrl);
		resolve({ width: 0, height: 0 });
	};

	image.src = objectUrl;
});
